module.exports = __webpack_public_path__ + "static/media/university-college-school-building-vector.20a23399.png";